/* VbyValee — small helpers (vanilla, no libraries) */
(function () {
  function initReveal() {
    var items = document.querySelectorAll('.vbv-reveal:not(.vbv-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('vbv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vbv-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Sticky buy bar: appears on phones once the real buy button scrolls out of view */
  function initStickyBuy() {
    var bar = document.querySelector('[data-vbv-sticky]');
    if (!bar || bar.dataset.ready) return;
    var main = document.querySelector('product-info .product-form__submit, .product-form__submit');
    if (!main) return;
    bar.dataset.ready = '1';
    var btn = bar.querySelector('[data-vbv-sticky-btn]');
    var priceEl = bar.querySelector('[data-vbv-sticky-price]');

    function syncButton() {
      var current = document.querySelector('product-info .product-form__submit, .product-form__submit');
      if (!current) return;
      btn.disabled = current.disabled || current.getAttribute('aria-disabled') === 'true';
      var label = current.querySelector('span');
      if (label && label.textContent.trim()) btn.textContent = label.textContent.trim();
    }
    function syncPrice() {
      var info = document.querySelector('product-info') || document;
      var sale = info.querySelector('.price .price-item--sale');
      var reg = info.querySelector('.price .price-item--regular');
      var el = sale && sale.textContent.trim() ? sale : reg;
      if (el && el.textContent.trim()) priceEl.textContent = el.textContent.trim();
    }

    btn.addEventListener('click', function () {
      var current = document.querySelector('product-info .product-form__submit, .product-form__submit');
      if (current && !current.disabled) current.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.tabIndex = show ? 0 : -1;
      }).observe(main);
    }

    var target = document.querySelector('product-info');
    if (target && 'MutationObserver' in window) {
      new MutationObserver(function () { syncPrice(); syncButton(); }).observe(target, { childList: true, subtree: true, characterData: true });
    }
    syncPrice();
    syncButton();
  }

  /* "Copy code" buttons (one delegated listener, works for every instance) */
  function fallbackCopy(text) {
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      ok ? resolve() : reject();
    });
  }
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () { return fallbackCopy(text); });
    }
    return fallbackCopy(text);
  }
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-vbv-copy]');
    if (!btn) return;
    copyText(btn.getAttribute('data-vbv-copy')).then(function () {
      var wrap = btn.closest('[data-vbv-welcome]');
      var status = wrap && wrap.querySelector('[data-vbv-copy-status]');
      btn.textContent = btn.getAttribute('data-copied');
      btn.classList.add('is-copied');
      if (status) status.textContent = btn.getAttribute('data-copied');
      setTimeout(function () {
        btn.textContent = btn.getAttribute('data-label');
        btn.classList.remove('is-copied');
      }, 2200);
    });
  });

  function init() { initReveal(); initStickyBuy(); }
  document.addEventListener('DOMContentLoaded', init);
  // Theme editor: re-run when a section is added or changed
  document.addEventListener('shopify:section:load', init);
})();

/* Klaviyo onsite (popup + tracking): loads only if the visitor has not refused marketing cookies */
(function () {
  var KEY = 'WguG6U';
  function load() {
    if (window.__vbvKlaviyo || document.querySelector('script[src*="klaviyo.com/onsite/js/klaviyo.js"]')) return;
    window.__vbvKlaviyo = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + KEY;
    document.head.appendChild(s);
  }
  function allowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || !cp.currentVisitorConsent) return true;
      return cp.currentVisitorConsent().marketing !== 'no';
    } catch (e) { return true; }
  }
  function start() { if (allowed()) load(); }
  document.addEventListener('visitorConsentCollected', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 600); });
  else setTimeout(start, 600);
})();